export function AddFilterButton({ onAddFilter }: { onAddFilter: () => void }) {
    return (
        <div className="flex flex-col gap-3">
            <button
                className="h-full px-2 py-4 transition generic-button"
                type="button"
                onClick={onAddFilter}
            >
               Add Filter
            </button>
        </div>
    );
}
